import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import { Button, Col, Divider, Row } from "antd";

import { Customer, CustomerFacility, OrderSummary } from "../../../../../../api-client";
import { useOrder } from "../../../../../../common/hooks/useOrder";
import { keepProductsRefinements, toggleCheckoutDrawer } from "../../../../../../slices/System/systemSlice";

import "./bv-customer-view.scss";

import BVShimmer from "../../../../../../common/components/BVShimmers/BVShimmer/bv-shimmer";
import BVAlert from "../../../../../../common/components/BVAlert/bv-alert";
import BVEmpty from "../../../../../../common/components/BVEmpty/bv-empty";
import BVCustomerDetails from "../BVCustomerDetails/bv-customer-details";
import BVCustomerFacilities from "../BVCustomerFacilities/bv-customer-facilities";
import BVOrdersGroupItem from "../BVOrdersGroupItem/bv-orders-group-item";

interface IBVCustomerView {
	customer?: Customer;
	customerLoading: boolean;
	facilities?: CustomerFacility[];
	facilitiesLoading: boolean;
	orders?: OrderSummary[];
	ordersLoading: boolean;
}

const BVCustomerView: React.FunctionComponent<IBVCustomerView> = ({
	customer,
	customerLoading,
	facilities,
	facilitiesLoading,
	orders,
	ordersLoading
}) => {
	const {
		handleRetrieveOrder,
		retrieveOrderLoading,
		resetOrderForCurrentCustomer
	} = useOrder();

	const history = useHistory();

	const _handleInitializeOrder = () => {
		resetOrderForCurrentCustomer();

		dispatch(keepProductsRefinements(undefined));

		if (customer) {
			_.includes(customer.posAssortment, "J") &&
			_.includes(customer.posAssortment, "W")
				? history.push("/catalog")
				: _.includes(customer.posAssortment, "J") &&
				  !_.includes(customer.posAssortment, "W")
				? history.push("/catalog/J")
				: history.push("/catalog/W");
		}
	};

	const dispatch = useDispatch();

	const _handleInitializeCustomerOrder = (order: OrderSummary) => {
		handleRetrieveOrder(order.id, () => dispatch(toggleCheckoutDrawer(true)));
	};

	const _customerBusinessUnitComparer = () =>
		customer && (_.includes(customer.posAssortment, "J") || _.includes(customer.posAssortment, "W")
		);

	return (
		<Fragment>
			<Row>
				<Col span={24} style={{ textAlign: 'right', marginBottom: 10 }}>
					<Button
						type="primary"
						size={'large'}
						disabled={!_customerBusinessUnitComparer()}
						onClick={() => _handleInitializeOrder()}
					>
						{'New Order'}
					</Button>
				</Col>
			</Row>

			<Divider />

			<div className="bv-orders-group-container-wrapper">
				<span className="heading">{customer?.fullName || "-"}</span>

				<BVShimmer loading={customerLoading} type={"shimmer-group"}>
					{!_customerBusinessUnitComparer() && (
						<BVAlert
							type={"warning"}
							message="No business units available for current customer"
						/>
					)}
				</BVShimmer>

				<BVShimmer loading={customerLoading} type={"shimmer-group"}>
					<BVCustomerDetails customer={customer} />
				</BVShimmer>

				<Divider />

				<BVShimmer loading={facilitiesLoading} type={"shimmer-group"}>
					<BVCustomerFacilities facilities={facilities} />
				</BVShimmer>

				<Divider />

				<BVShimmer loading={ordersLoading} type={"shimmer-group"}>
					<BVEmpty
						dataSource={orders || []}
						disclaimer={"No orders found for selected customer."}
					>
						{_.map(orders, (dataItem, dataIndex) => (
							<BVOrdersGroupItem
								key={dataIndex}
								order={dataItem}
								orderLoading={retrieveOrderLoading}
								onClick={_handleInitializeCustomerOrder}
							/>
						))}
					</BVEmpty>
				</BVShimmer>
			</div>
		</Fragment>
	);
};

export default BVCustomerView;
